exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h3[data-v-077497ec] {\n  font-size: 1.5rem;\n}\np[data-v-077497ec] {\n  font-size: 1rem;\n  font-weight: lighter;\n}", ""]);

// exports
